import {gsap} from "../../libs/gsap/all.js"
import {Howl} from "howler";

export class KeepSpeakersAlive {

  constructor(delay = 60) {
    this.sound = new Howl({
      src: ['audio/20hz-sine-wave.wav'],
      loop: false,
      autoplay: false,
      volume: 1,
    });

    this.tl = gsap.timeline({repeat: -1})
    this.tl.add(() => {
      this.sound.play();
    }, delay)
  }

  start() {
    this.tl.play(0)
  }

  stop() {
    this.tl.pause()
  }
}
